type TalkingProps = {
  color?: string;
};

const Talking = ({ color = '#f9f9f9' }: TalkingProps) => {
  return (
    <svg
      width="209"
      height="132"
      viewBox="0 0 209 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2201_10262)">
        <path
          d="M20.9344 132C19.8507 132 18.7842 131.427 18.1133 130.358C6.2657 111.443 0 89.1875 0 66.0021C0 42.8168 6.2657 20.5559 18.1176 1.6417C19.2099 -0.101412 21.3558 -0.520338 22.9083 0.697917C24.465 1.92099 24.8392 4.32379 23.7512 6.06209C12.712 23.6762 6.88066 44.4058 6.88066 66.0021C6.88066 87.5984 12.712 108.323 23.7512 125.937C24.8435 127.68 24.465 130.083 22.9083 131.301C22.3062 131.773 21.6182 132 20.9344 132ZM37.8694 118.724C36.7857 118.724 35.7192 118.151 35.0527 117.087C25.6262 102.054 20.642 84.3915 20.642 66.0021C20.642 47.6127 25.6262 29.9505 35.0527 14.9173C36.145 13.1742 38.2909 12.7553 39.8433 13.9783C41.4001 15.2014 41.7742 17.6042 40.6819 19.3425C32.0725 33.0707 27.5183 49.2018 27.5183 65.9973C27.5183 82.7928 32.0682 98.9239 40.6776 112.652C41.7699 114.395 41.3958 116.798 39.839 118.016C39.237 118.488 38.5489 118.714 37.8651 118.714L37.8694 118.724ZM54.7743 105.468C53.6906 105.468 52.6241 104.895 51.9576 103.831C44.978 92.6978 41.284 79.6196 41.284 66.0021C41.284 52.3846 44.9737 39.3065 51.9576 28.1736C53.0499 26.4305 55.1958 26.0116 56.7482 27.2347C58.305 28.4577 58.6791 30.8605 57.5868 32.5988C51.4243 42.4267 48.1646 53.9785 48.1646 66.0021C48.1646 78.0257 51.4243 89.5775 57.5868 99.4054C58.6791 101.148 58.305 103.551 56.7482 104.77C56.1462 105.241 55.4581 105.468 54.7743 105.468Z"
          fill="url(#paint0_linear_2201_10262)"
        />
        <path
          d="M188.065 132C187.381 132 186.693 131.774 186.091 131.302C184.535 130.079 184.16 127.676 185.248 125.938C196.283 108.323 202.119 87.5986 202.119 66.0023C202.119 44.406 196.288 23.6812 185.253 6.06712C184.16 4.324 184.539 1.9212 186.096 0.702948C187.652 -0.520121 189.798 -0.0963807 190.886 1.64673C202.738 20.5658 209.004 42.817 209.004 66.0071C209.004 89.1973 202.738 111.453 190.886 130.368C190.215 131.437 189.149 132.01 188.065 132.01V132ZM171.126 118.724C170.442 118.724 169.754 118.498 169.152 118.026C167.595 116.803 167.221 114.4 168.313 112.662C176.923 98.9337 181.473 82.8027 181.473 66.0071C181.473 49.2116 176.923 33.0806 168.309 19.3523C167.217 17.6092 167.591 15.2112 169.148 13.9882C170.704 12.7651 172.846 13.184 173.938 14.9271C183.365 29.9603 188.349 47.6226 188.349 66.012C188.349 84.4013 183.365 102.064 173.938 117.097C173.268 118.166 172.201 118.734 171.122 118.734L171.126 118.724ZM154.225 105.468C153.542 105.468 152.853 105.242 152.251 104.77C150.695 103.547 150.321 101.144 151.413 99.4056C157.575 89.5777 160.835 78.026 160.835 66.0023C160.835 53.9787 157.575 42.4269 151.413 32.599C150.321 30.8559 150.695 28.4531 152.251 27.2349C153.808 26.0118 155.954 26.4307 157.042 28.1739C164.026 39.3067 167.716 52.3897 167.716 66.0023C167.716 79.615 164.026 92.698 157.042 103.831C156.371 104.9 155.305 105.468 154.225 105.468Z"
          fill="url(#paint1_linear_2201_10262)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2201_10262"
          x1="3.5"
          y1="66"
          x2="40.5"
          y2="66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#D9FFFA" />
          <stop offset="0.48" stop-color="#99D2FE" />
          <stop offset="1" stop-color="#FBBAFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2201_10262"
          x1="164"
          y1="66"
          x2="205.791"
          y2="66.0064"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBBAFF" />
          <stop offset="0.52" stop-color="#99D2FE" />
          <stop offset="1" stop-color="#D9FFFA" />
        </linearGradient>
        <clipPath id="clip0_2201_10262">
          <rect width="209" height="132" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Talking;
